import appSettings from 'wanderu-config';
import {
    createAccountAction,
    updateBillingAddressAction,
} from 'wanderu-ducks-account';
import { selectLocale } from 'wanderu-i18n';
import Logger from 'wanderu-logger';
import { SnowplowService } from 'wanderu-service-analytics';
import { TixService } from 'wanderu-service-wapi';

import {
    selectors as bookingSelectors,
} from '../../appstate';
import {
    actions,
    namespace,
    reducer,
    selectors,
} from './base';

const logger = Logger.getLogger('wanderu-app-booking:createAssociatedAccount');

function _associateOrderWithUser() {
    return async (dispatch, getState) => {
        const {
            itineraryId,
            bookingSessionId,
            tripIds,
        } = bookingSelectors.selectBookingInfo(getState());

        // we only need the first processingId to associate all purchases over the past day that match the identity id with the user
        const firstTripId = tripIds[0];
        const processingId = bookingSelectors.selectProcessingId(getState(), firstTripId);

        const body = {
            processingId,
            itinerary_id: itineraryId,
            booking_session_id: bookingSessionId,
        };

        // TODO How should we handle errors? Ui3 currently just swallows them
        await TixService.post('v3/trips/visibility', { body });
    };
}

function createAssociatedAccount(password) {
    return async (dispatch, getState) => {
        dispatch(actions.startWork());

        let error;
        let meta;
        try {
            const userInfo = bookingSelectors.selectUserFormInfo(getState());

            const basicAccountInfo = {
                password,
                email: userInfo.email,
                firstName: userInfo.firstName,
                lastName: userInfo.lastName,
                locale: selectLocale(getState()),
            };

            const billingInfo = {
                street: userInfo.street,
                street2: userInfo.street2,
                city: userInfo.city,
                stateProvince: userInfo.stateProvince,
                country: userInfo.country,
                phone: userInfo.phone,
                postalCode: userInfo.postalCode,
            };

            await dispatch(createAccountAction.createAccountAndLogIn(basicAccountInfo));

            const createAccountError = createAccountAction.selectError(getState());

            if (createAccountError) {
                throw createAccountError;
            }

            await Promise.all([
                dispatch(_associateOrderWithUser()),
                dispatch(updateBillingAddressAction.update(billingInfo)),
            ]);
        } catch (ex) {
            const domainUserInfo = appSettings.env.isClient
                ? SnowplowService.getDomainUserInfo()
                : {};

            logger.error('createAssociatedAccount', ex, {
                snowplowIds: {
                    networkUserId: SnowplowService.getNetworkUserId(),
                    ...domainUserInfo,
                },
            });
            error = {
                code: ex.code,
                message: ex.message,
                name: ex.name,
            };
        } finally {
            dispatch(actions.endWork(meta, error));
        }
    };
}

const createAssociatedAccountAction = {
    create: createAssociatedAccount,
    reset: actions.reset,
    ...selectors,
};

export {
    createAssociatedAccountAction,
};

export default {
    [namespace]: reducer,
};
